<template>
  <div class="p-search-modal__input">
    <Loader v-if="searchInProgress"></Loader>

    <div class="p-search-modal__input__holder" :class="extraInputClass">
      <button
        v-if="showSearchBtn"
        type="button"
        class="p-search-modal__btn-search"></button>
      <input
        type="text"
        :placeholder="placeholder"
        :value="modelValue"
        :readonly="searchInProgress"
        @input="emitModelValue" />
      <button
        type="button"
        :class="inputRightButton"
        @click="emptyInput"></button>
    </div>
    <div
      v-if="showResultCounter && showTotalCounter"
      class="p-search-modal__results">
      <div class="p-search-modal__results__txt">
        <span>{{ totalResult }}</span>
        {{ dictionary.results }}
      </div>
    </div>
  </div>
</template>

<script setup>
import Loader from '../Shared/Loader.vue'

import { computed } from 'vue'
const props = defineProps({
  modelValue: { default: '', type: String },
  totalResult: { default: 0, type: Number },
  searchInProgress: { default: true, type: Boolean },
  placeholder: { default: '', type: String },
  showTotalCounter: { default: false, type: Boolean },
  debounce: { default: 400, type: Number },
})

const emit = defineEmits(['update:modelValue'])
const showResultCounter = computed(() => {
  return !props.searchInProgress && props.modelValue.length >= 3
})

let debounceTimer = 0

const emitModelValue = (event) => {
  clearTimeout(debounceTimer)

  debounceTimer = setTimeout(() => {
    emit('update:modelValue', event.target.value)
  }, props.debounce)
}

const showSearchBtn = computed(() => {
  return inputFocused.value
})

const extraInputClass = computed(() => {
  return props.modelValue ? 'has-value' : ''
})

const inputFocused = computed(() => {
  return props.modelValue ? true : false
})

const inputRightButton = computed(() => {
  return showSearchBtn.value
    ? 'p-search-modal__clear btn-close btn-close--grey'
    : 'p-search-modal__btn-search'
})

const emptyInput = () => {
  emit('update:modelValue', '')
}
</script>
